"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lumezzane": {
    "26307396": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "cargne": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "534cfd4c": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "dosso": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2d3f3b07": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "faidana": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a50a942": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "fontana": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bc627d6c": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "gombaiolo": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9c22a45": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "lumezzane-gazzolo": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "527567bc": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "lumezzane-pieve": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a58ea59": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "lumezzane-san-sebastiano": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d9d4cb7": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "lumezzane-sant-apollonio": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "649a67d4": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "mezzaluna": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10649be1": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "montagnaone": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96056c15": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "mosniga": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "721de859": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "piatucco": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9110a20": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "premiano": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0e645f2a": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "renzo": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d32df254": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "rossaghe": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "997386e9": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "sonico": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2860f882": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "termine": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "800a85ae": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f4a67d8a": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-gnutti": [{
      "hkey": "e56a7b35",
      "slug": "lumezzane",
      "name": "Lumezzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;